import sample_1 from './greiffStrick.jpg';

export const greiffStrickImpressions = {
    sample_1,
};
